import { render } from "./capital-tile.vue?vue&type=template&id=02c189dc&scoped=true&ts=true"
import script from "./capital-tile.vue?vue&type=script&lang=ts"
export * from "./capital-tile.vue?vue&type=script&lang=ts"

import "./capital-tile.vue?vue&type=style&index=0&id=02c189dc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c189dc"]])

export default __exports__